import React from 'react';
import './index.css';
import { TextField, Button, Box, CircularProgress, IconButton, Stack } from '@mui/material';
import { Visibility,VisibilityOff } from '@mui/icons-material';
import {Card,Typography,CardMedia,InputAdornment} from '@mui/material';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import EmailIcon from '@mui/icons-material/Email';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import * as ETVConstants from './ETVConstants';
import ETVActionButton from './tools/ETVActionButton';
import ETVMessagePopup from './tools/ETVMessagePopup';
import ETVPopup from './tools/ETVPopup';

class Login extends React.Component {
    constructor(props) {
      super(props);
      document.title = "elevator.tv"
    }

    componentDidMount() {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    componentWillUnmount() {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    state={
      userNameOK:true,
      passwordOK:true,
      window:'',
      show_overlay:false,
      show_login_div:true,
      info_message_title:'Error',
      info_message:'',
      send_pw_addr:'',
      email_helper_ok:true,
      cur_pw: '',
      new_pw1: '',
      new_pw1_helper_ok:true,
      new_pw2: '',
      new_pw2_helper_ok:true,
      username:'',
      password:'',
      login_btn_active: true,
      send_email_helper_ok:true,
      cur_pw_helper_ok:true,
      reset_pw1: '',
      reset_pw1_helper: '',
      reset_pw2: '',
      reset_pw2_helper_ok:true,
      status: undefined,
      children:[],
      otp:'',
      error_reason:0,
      show_password:false,
    }

    loginFunc() {
      this.setState({login_btn_active:false});
      var username = this.state.username;
      var password = this.state.password;
      const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({action: 'login', username:username, password:password })
      };
      var url = ETVConstants.getServerBase()+'/useradmin';
      //console.log("url="+url);
      fetch(url, requestOptions)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({login_btn_active:true});
          if(!result["user_exists"]) {
            this.setState({userNameOK:false,username:'',password:''})
            return;
          }

          if(!result['active']) {
            this.setState({show_login_div:false});
            var parent = result['parent'];
            this.showInfoMessage("Account Inactive","Please contact your administrator ("+parent['user_name']+")");
            return;
          }

          if(!result['activation']) {
            this.setState({show_login_div:false});
            var parent1 = result['parent'];
            this.showInfoMessage("Account not activated","Please activate your account or contact your administrator ("+parent1['user_name']+")");
            return;
          }

          this.setState({userNameOK:true});

          if(!result["password_ok"]) {
            this.setState({password:'',passwordOK:false});
            return;
          }

          if(result['need_pw_update']) {
            this.setState({user_id:result['user_id'],access_token:result["access_token"]});
            this.showWindow("forced_pw_change_div",true);
            return;
          }

          //// all ok
          if(result["otp_requested"]) {
            this.showWindow("otp_div",true);
            this.setState({user_id:result['user_id']});
            return;

          }else{
            // all ok
            var roles = result["roles"];
            //console.log("roles="+roles);
            var status = result["status"];
            var accessToken = result["access_token"];
            var children = result["children"];
            //console.log("children="+children);

            //console.log("---> 123 user="+JSON.stringify(result));
            localStorage.setItem("etv.access_token",accessToken);
            localStorage.setItem("etv.user_id",result['user_id']);
            localStorage.setItem("etv.user_name",result['username']);

            // New: Fetch IP-based location
            fetch("https://ipapi.co/json/")
              .then(res => res.json())
              .then(geo => {
                const countryCode = geo?.country || "SG";
                localStorage.setItem("etv.country_code", countryCode);
            })
            .catch(() => {
              // fallback if geo lookup fails
              localStorage.setItem("etv.country_code", "SG");
            });
            this.setState({passwordOK:true, children:children, roles: roles, status:status, username:'',password:''});
            //console.log("---->11234 Logging in, userID="+result['user_id']+" username="+result['username']+" lang="+result['lang']);
            this.props.loggedInCallback(true, result['user_id'], result['username'], roles, children, status, result['lang']);
          }
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          //console.log("xxxx error login err="+JSON.stringify(error));
          this.setState({login_btn_active:true});
        }
      )

    };

    showWindow(divID, show) {
      this.setState({show_overlay:show});
      show?this.setState({window:divID}):this.setState({window:''});
    }

    showInfoMessage(title,text) {
      this.setState({info_message_title:title,info_message:text});
      this.showWindow('message_div',true);
    }

    closeInfoMessage() {
      this.setState({info_message:undefined, show_login_div:true});
      this.showWindow('message_div',false);
    }

    showResetPW() {
      this.showWindow('reset_password_div',true);
    }

    showForgotPW() {
      this.showWindow("forgot_password_div",true);
    }

    sendPW() {
      //console.log("sending pw to "+this.state.send_pw_addr);
      this.showInfoMessage('Password','Reset Link sent to user');
    }

    isEmail( emailAddr) {
      const EMAIL_REGEX =  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
      return EMAIL_REGEX.test(emailAddr);
    }

    sendPWChange(username, curPW, newPW) {
        const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({action: 'change_password', cur_pw: curPW, username:username, password:newPW })
        };
        fetch(ETVConstants.getServerBase()+'/useradmin', requestOptions)
            .then((response) => response.json())
            .then((responseJson) => {
                        //console.log("----> changePW result="+JSON.stringify(responseJson));
                if(!responseJson["result"]) {
                if(responseJson["reason"]==='user_does_not_exist') {
                    this.showInfoMessage(ETVConstants.trans("error"),ETVConstants.trans("user_does_not_exist"));
                    return;
                }
                this.setState({cur_pw_helper_ok:false});
                return;
                }
                this.showInfoMessage(ETVConstants.trans("success"),ETVConstants.trans("password_successfully_changed"));
            })
            .catch((error) => {
                        this.showInfoMessage(ETVConstants.trans("error"),ETVConstants.trans(error));
            });
	}

    resetPW() {
      //console.log("reset PW, email="+this.state.username+" cur="+this.state.cur_pw+" new="+this.state.new_pw1+" repeat="+this.state.new_pw2);
      this.setState({email_helper_ok:true, new_pw1_helper_ok:true, new_pw2_helper_ok:true});
      if(!this.isEmail(this.state.username)) {
        this.setState({email_helper_ok:false});
        return;
      }
      if(!this.state.new_pw1) {
        this.setState({new_pw1_helper_ok:false});
        return;
      }
      if(!this.state.new_pw2) {
        this.setState({new_pw2_helper_ok:false});
        return;
      }
      if(this.state.new_pw2!==this.state.new_pw1) {
        this.setState({new_pw2_helper_ok:false});
        return;
      }
      this.sendPWChange(this.state.username, this.state.cur_pw, this.state.new_pw1);
    }

    checkResendPW() {
        this.setState({send_email_helper_ok:true});
        if(!this.isEmail(this.state.send_pw_addr)) {
          this.setState({send_email_helper_ok:false});
          return;
        }
        this.resendPW(this.state.send_pw_addr);
    }

    resendPW(email) {
      // is not logged in!
      var url = ETVConstants.getServerBase()+'/useradmin?action=send_password&username='+email;
      fetch(url)
      .then((response) => response.json())
      .then((responseJson) => {
        if(!responseJson['result']) {
          //console.log(JSON.stringify(responseJson));
          this.showInfoMessage(ETVConstants.trans('error'),ETVConstants.trans(responseJson['reason']));
          return;
        }
        this.showInfoMessage(ETVConstants.trans('success'),ETVConstants.trans("email_was_sent"));
         //this.showWindow('info_message_div',false);
         //this.setState({info_message:'successfully changed password'});
      })
      .catch((error) => {
         this.showInfoMessage(ETVConstants.trans('error'),"Error: "+error);
      });
    }

    getPaymentInfoLink() {
      var urlStr = window.location.href;
      if (urlStr.indexOf("payment_info=")>0) {
        var info = urlStr.substring(urlStr.indexOf("payment_info=")+"payment_info".length+1,urlStr.length);
        return info;
      }else{
        return undefined;
      }
    }

    getResetPWLink() {
      var urlStr = window.location.href;
      if (urlStr.indexOf("reset_id=")>0) {
        var resetID = urlStr.substring(urlStr.indexOf("reset_id=")+"reset_id".length+1,urlStr.length);
        return resetID;
      }else{
        return undefined;
      }
    }

    changeUserPW( resetID) {
	  if(this.state.reset_pw1.length<6) {
		 this.setState({reset_pw1_helper:ETVConstants.trans('password_at_least_6_characters')});
		 return;
	  }
       if(this.state.reset_pw1!==this.state.reset_pw2) {
         this.setState({reset_pw2_helper:"password mismatch"});
         return;
       }
       this.resetPWServer(resetID,this.state.reset_pw1);
    }

    resetPWServer(resetID,pw) {
      this.showInfoMessage(ETVConstants.trans("reset"),"sending reset password");
      var url = ETVConstants.getServerBase()+"/useradmin?action=reset_pw&reset_id="+encodeURIComponent(resetID)+"&password="+encodeURIComponent(pw);
      fetch(url)
      .then((response) => response.json())
      .then((responseJson) => {
        if(!responseJson['result']) {
          this.showInfoMessage(ETVConstants.trans('error'),ETVConstants.trans(responseJson['reason'] || responseJson['error'] || 'failed_to_update_password'));
          return;
        }
        window.location.href="/";
      })
      .catch((error) => {
         this.showInfoMessage('Info',"Error: "+error);
      });
    }

    enforceNewPw() {
      var url = ETVConstants.getServerBase()+"/useradmin?action=change_password&user_id="+this.state.user_id+"&password="+this.state.new_pw1;
      fetch(url,{ headers: { 'user_id':this.state.user_id, 'access_token': this.state.access_token }})
      .then((response) => response.json())
      .then((responseJson) => {
        //console.log(JSON.stringify(responseJson));
        if(!responseJson['result']) {
          if(responseJson['reason']==='same_password') {
            this.setState({new_pw1_helper_ok:false, error_reason:1});
            this.setState({new_pw2:''});
            return;
          }
          if(responseJson['reason']==='not_secure_password') {
            this.setState({new_pw1_helper_ok:false, error_reason:2});
            this.setState({new_pw2:''});
            return;
          }
        }
        this.showInfoMessage(ETVConstants.trans('success'),ETVConstants.trans("password_successfully_changed"));
        window.location.href="/";
      })
      .catch((error) => {
         this.showInfoMessage('Info',"Error: "+error);
      });
    }

    submitOTP(otp) {
      var url = ETVConstants.getServerBase()+'/useradmin?action=validate_otp&user_id='+this.state.user_id+"&otp="+this.state.otp;
      //console.log(url);
      fetch(url)
      .then((response) => response.json())
      .then((result) => {
        //console.log("otp result="+JSON.stringify(result));
        var validOTP = result["valid_otp"];
        if(validOTP) {
            var roles = result["roles"];
            var status = result["status"];
            var accessToken = result["access_token"];
            //console.log("---> access_token="+accessToken);
            localStorage.setItem("etv.access_token",accessToken);
            localStorage.setItem("etv.user_id",result['user_id']);
            //console.log("-------------------->roles="+roles+" status="+status);
            this.setState({passwordOK:true, roles: roles, status:status, username:'',password:''});
            //console.log("---->Logging in, userID="+result['user_id']+" username="+result['username']+" lang1="+result["lang"]);
            this.props.loggedInCallback(true, result['user_id'], result['username'], roles, status, result["lang"]);
        }else{
          this.showInfoMessage(ETVConstants.trans("error"),"Error: invalid OTP");
        }
      })
      .catch((error) => {
         this.showInfoMessage(ETVConstants.trans("error"),"Error: "+error);
      });
    }

    gotoLogin() {
      window.location.href = window.location.origin;
    }

    isOnPremise( domain) {
      var temp = domain.trim().toLowerCase();
      if(temp === 'localhost') return true;
      if(temp.startsWith('10.')) return true;
      if(temp.startsWith('172.')) return true;
      if(temp.startsWith('127.')) return true;
      if(temp.startsWith('192.168.')) return true;
      return false;
    }

    isValidEmail( email) {
      if(!email) return false;
      if(email.trim().length===0) return false;
  		return ETVConstants.EMAIL_REGEX.test(email);
    }

    receiveBackupServerInfo( res ) {
      //console.log("receiveBackupServerInfo="+res);
      var isRunningAsMaster = res.running_as_master;
      var serverAddr = res.server_address;
      //console.log("isRunningAsMaster="+isRunningAsMaster+" serverAddr="+serverAddr);
      if(!isRunningAsMaster) {
        var forwardURL = "http://"+serverAddr;
        //console.log("forwardURL="+forwardURL);
        //window.location.href=forwardURL;
        return;
      }
    }

    render() {
        if(ETVConstants.ON_PREMISE_VERSION) {
          //check if this is the backup server and active or not.
          //if not active, then redirect to the server
          var url = ETVConstants.getServerBase()+"/backup_servlet_slave?action=info";
          //console.log("url to check="+url);
          ETVConstants.sendCMDToServerListener(url, this.receiveBackupServerInfo);
        }
        ETVConstants.setFavicon();
        //var domain = window.location.hostname;
        var paymentinfo = this.getPaymentInfoLink();
        var resetID = this.getResetPWLink();
        //console.log("domain="+domain);
        //console.log("window.location.href="+window.location.href);

        return (
          paymentinfo?
            <div style={{margin:'auto', marginTop:300, width:300, height: 300}}>
              <Card>
                <CardContent>
                  <Typography gutterBottom variant="subtitle1">
                  Payment {paymentinfo==='success'?"success":"failed"}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button color="primary" variant='outlined' onClick={() => {this.gotoLogin()}}>ok</Button>
                </CardActions>
              </Card>
            </div>
          :resetID?
            <Box sx={{position:'fixed',inset:0,display:'flex',alignItems:'center',justifyContent:'center',p:2.5,overflowY:'auto',background:'linear-gradient(145deg,#eef4fb 0%,#f8fafc 55%,#e9f1fa 100%)'}}>
              <Card elevation={0} sx={{width:'100%',maxWidth:500,p:{xs:2.5,sm:4},border:'1px solid',borderColor:'divider',borderRadius:4,boxShadow:'0 20px 55px rgba(31,41,55,.12)'}}>
                <CardMedia component="img" image={ETVConstants.getLogo()} sx={{width:'100%',height:82,objectFit:'contain',mb:2}} />
                <CardContent sx={{p:0}}>
                  <Typography variant="h4" align="center" sx={{fontWeight:700,color:'#14213d'}}>{ETVConstants.trans('reset_password')}</Typography>
                  <Typography variant="body1" align="center" color="text.secondary" sx={{mt:1,mb:3}}>Choose a secure new password for your Elevator TV account.</Typography>
                  <Stack spacing={2.25}>
                    <TextField size="medium" id="pw1" error={!!this.state.reset_pw1_helper} helperText={this.state.reset_pw1_helper} label={ETVConstants.trans('new_password')} type="password" fullWidth autoFocus required onChange={(e)=>this.setState({reset_pw1:e.target.value,reset_pw1_helper:''})}/>
                    <TextField size="medium" id="pw2" error={!!this.state.reset_pw2_helper} helperText={this.state.reset_pw2_helper} label={ETVConstants.trans('repeat_password')} type="password" fullWidth required onInput={()=>this.setState({reset_pw2_helper:''})} onChange={(e)=>this.setState({reset_pw2:e.target.value})}/>
                    <Box sx={{p:2,borderRadius:2.5,bgcolor:'#f4f8fd',border:'1px solid #dce8f5'}}>
                      <Typography variant="body2" sx={{fontWeight:700,color:'#315a8a',mb:.5}}>Password requirements</Typography>
                      <Typography variant="body2" color="text.secondary">• {ETVConstants.trans('password_at_least_6_characters')}</Typography>
                      <Typography variant="body2" color="text.secondary">• {ETVConstants.trans('same_password')}</Typography>
                    </Box>
                    <Button fullWidth disabled={this.state.reset_pw1.length<6 || this.state.reset_pw2!==this.state.reset_pw1} endIcon={<ChangeCircleIcon/>} size="large" color="primary" variant="contained" onClick={()=>this.changeUserPW(resetID)} sx={{minHeight:54,fontWeight:700}}>{ETVConstants.trans('reset_password')}</Button>
                  </Stack>
                </CardContent>
              </Card>
            </Box>
          :
          <div>
          {this.state.show_login_div===true?
            <Box id="login_div" sx={{display:'grid',gridTemplateColumns:{xs:'1fr',md:'minmax(0,3fr) minmax(360px,1fr)'},bgcolor:'#f7f9fc'}}>
                <Box
                  sx={{
                    display:{xs:'none',md:'flex'},
                    position:'relative',
                    height:'100vh',
                    backgroundImage:`linear-gradient(135deg, rgba(3,15,32,.38), rgba(7,35,75,.10)), url("${ETVConstants.getLoginBackgroundImage()}")`,
                    backgroundSize:'cover',
                    backgroundPosition:'center',
                    color:'#fff',
                  }}
                >
                  <Typography
                    component="h1"
                    className="login-brand-title"
                    sx={{
                      position:'absolute',
                      left:{md:42,lg:64},
                      top:{md:38,lg:48},
                      maxWidth:'88%',
                      color:'#fff',
                      fontFamily:'"ETV Simplifica", sans-serif',
                      fontSize:ETVConstants.ON_PREMISE_VERSION
                        ? {md:104,lg:136,xl:160}
                        : {md:82,lg:108,xl:128},
                      lineHeight:.96,
                      fontWeight:400,
                      letterSpacing:'.015em',
                      textShadow:'0 3px 2px rgba(0,0,0,.72), 0 10px 34px rgba(0,0,0,.72), 0 0 22px rgba(13,45,79,.55)',
                    }}
                  >
                    {ETVConstants.getBrandName()}
                  </Typography>
                  <Typography
                    sx={{
                      position:'absolute',
                      left:{md:42,lg:64},
                      maxWidth:'52%',
                      bottom:{md:82,lg:88},
                      color:'#fff',
                      fontFamily:'"Segoe Script", "Brush Script MT", cursive',
                      fontSize:{md:50,lg:64,xl:76},
                      lineHeight:1.15,
                      fontWeight:500,
                      fontStyle:'italic',
                      letterSpacing:'-.015em',
                      textShadow:'0 3px 18px rgba(0,0,0,.72)',
                    }}
                  >
                    where innovation meets vertical transportation
                  </Typography>
                  <Box sx={{position:'absolute',left:0,right:0,bottom:0,minHeight:58,display:'flex',alignItems:'center',justifyContent:'space-between',gap:2,px:{md:2.5,lg:3},py:.75,bgcolor:'rgba(3,12,24,.42)',backdropFilter:'blur(8px)',borderTop:'1px solid rgba(255,255,255,.16)'}}>
                    <Box sx={{display:'flex',alignItems:'center',gap:.25,whiteSpace:'nowrap'}}>
                      <Button size="medium" color="inherit" sx={{fontSize:13,fontWeight:600}} onClick={()=>this.setState({window:'terms_condition_div'})}>Terms &amp; Conditions</Button>
                      <Button size="medium" color="inherit" sx={{fontSize:13,fontWeight:600}} onClick={()=>this.setState({window:'data_protection_div'})}>Privacy Policy</Button>
                      <Button size="medium" color="inherit" sx={{fontSize:13,fontWeight:600}} onClick={()=>this.setState({window:'contact_div'})}>{ETVConstants.trans('contact')}</Button>
                    </Box>
                    <Typography variant="body2" sx={{fontSize:13,fontWeight:600,whiteSpace:'nowrap',opacity:.95}}>
                      ©{new Date().getFullYear()} {ETVConstants.getCompany()} {' | v' + ETVConstants.VERSION}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',p:{xs:2.5,sm:4,md:3},pb:{xs:8,md:8}}}>
                <Card elevation={0} sx={{width:'100%',maxWidth:410,p:{xs:2.5,sm:3},border:'1px solid',borderColor:'divider',borderRadius:4,boxShadow:'0 18px 45px rgba(31,41,55,.12)'}}>
                    <CardMedia
                        sx={ETVConstants.ON_PREMISE_VERSION
                          ? {width:'100%',height:124,objectFit:'contain',mb:2.5}
                          : {width:'116%',height:154,objectFit:'contain',ml:'-8%',mb:2.5}}
                        image={ETVConstants.getLogo()}
                        component="img"
                    />
                    <CardContent sx={{px:0}}>
                        <Box>
                          <Typography component="label" htmlFor="username" sx={{display:'block',mb:.75,fontSize:15,fontWeight:600,color:'#172033'}}>
                            {ETVConstants.trans("username")}
                          </Typography>
                          <TextField size="medium" id="username" required autoFocus value={this.state.username}
                            disabled={!this.state.login_btn_active}
                            error={!this.state.userNameOK}
                            helperText={this.state.userNameOK?'':ETVConstants.trans("user_does_not_exist")}
                            type="email"
                            onInput={(e)=>{this.setState({username:e.target.value,userNameOK:true})}}
                            fullWidth={true}
                            sx={{
                              backgroundColor:'white',
                              '& .MuiOutlinedInput-root':{minHeight:56,backgroundColor:'white',fontSize:17,borderRadius:2},
                              '& input':{backgroundColor:'white !important'},
                              '& input:-webkit-autofill':{WebkitBoxShadow:'0 0 0 1000px white inset',WebkitTextFillColor:'#172033'},
                            }}
                            variant="outlined" />
                        </Box>

                        <Box sx={{mt:2}}>
                          <Typography component="label" htmlFor="password" sx={{display:'block',mb:.75,fontSize:15,fontWeight:600,color:'#172033'}}>
                            {ETVConstants.trans("password")}
                          </Typography>
                          <TextField size="medium" id="password" required value={this.state.password}
                            disabled={!this.state.login_btn_active}
                            error={!this.state.passwordOK}
                            helperText={this.state.passwordOK?'':ETVConstants.trans("wrong_password")}
                            type={this.state.show_password?"text":"password"}
                            onInput={(e)=>{this.setState({password:e.target.value,passwordOK:true})}}
                            fullWidth={true}
                            sx={{
                              backgroundColor:'white',
                              '& .MuiOutlinedInput-root':{minHeight:56,backgroundColor:'white',fontSize:17,borderRadius:2},
                              '& input':{backgroundColor:'white !important'},
                              '& input:-webkit-autofill':{WebkitBoxShadow:'0 0 0 1000px white inset',WebkitTextFillColor:'#172033'},
                            }}
                            InputProps={{
                                endAdornment: 
                                    <InputAdornment position="end">
                                        <IconButton
                                                aria-label={ETVConstants.trans("show_password")}
                                                onClick={(event)=>{this.setState({show_password:this.state.show_password?false:true})}}
                                                edge="end">
                                                    {this.state.show_password ? <VisibilityOff/> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>,
                            }}
                            variant="outlined" />
                        </Box>

                            <Button variant="contained" 
                                    disabled={!this.state.login_btn_active || !this.state.username || this.state.username.trim().length===0 || !this.state.password || this.state.password.trim().length===0 }
                                    size="large"
                                    startIcon={!this.state.login_btn_active?<CircularProgress size={20} color="inherit"/>:<ShieldOutlinedIcon sx={{fontSize:19}}/>}
                                    fullWidth 
                                    onClick={()=>this.loginFunc()}
                                    sx={{
                                      mt:2,
                                      minHeight:55,
                                      borderRadius:'11px',
                                      background:'linear-gradient(100deg,#2196ef 0%,#1474c6 100%)',
                                      boxShadow:'0 11px 24px rgba(23,119,199,.24)',
                                      fontSize:16,
                                      fontWeight:700,
                                      textTransform:'none',
                                      '&:hover':{
                                        background:'linear-gradient(100deg,#1689df 0%,#0e68b7 100%)',
                                        boxShadow:'0 13px 27px rgba(23,119,199,.30)',
                                      },
                                    }}>{this.state.login_btn_active?ETVConstants.trans("login"):ETVConstants.trans("login")+'...'}</Button>
                    </CardContent>
                    <CardActions sx={{px:0,pt:0,justifyContent:'space-between',flexWrap:'wrap'}}>
                      {ETVConstants.ON_PREMISE_VERSION?<span/>:<Button size='small' color="primary" onClick={() => this.showForgotPW()}>{ETVConstants.trans("forgot_password")}</Button>}
                      <Button size='small' color="primary" onClick={() => this.showResetPW()}>{ETVConstants.trans("reset_password")}</Button>
                    </CardActions>
                  </Card>
                </Box>
              </Box>
              :
              <span/>
            }

            <ETVMessagePopup
              open={this.state.window==='message_div'}
              onClose={()=>this.closeInfoMessage()}
              type={this.state.info_message_title===ETVConstants.trans('success')?'success':'error'}
              title={this.state.info_message_title}
              message={this.state.info_message}
              closeLabel={ETVConstants.trans('close')}
            />

            <ETVPopup
              open={this.state.window==='otp_div'}
              onClose={()=>this.showWindow('otp_div',false)}
              width="small"
              title={ETVConstants.trans('one_time_password')}
              bottomActions={<><ETVActionButton action="cancel" label={ETVConstants.trans('cancel')} onClick={()=>this.showWindow('otp_div',false)}/><ETVActionButton action="send" label={ETVConstants.trans('submit')} disabled={this.state.otp.trim().length!==6} onClick={()=>this.submitOTP()}/></>}
            >
              <TextField id="otp_field" label={ETVConstants.trans('otp_password')} fullWidth autoFocus required onChange={(e)=>this.setState({otp:e.target.value})}/>
            </ETVPopup>

            <ETVPopup
              open={this.state.window==='reset_password_div'}
              onClose={()=>this.showWindow('reset_password_div',false)}
              width="small"
              title={ETVConstants.trans('reset_password')}
              bottomActions={<><ETVActionButton action="cancel" label={ETVConstants.trans('cancel')} onClick={()=>this.showWindow('reset_password_div',false)}/><ETVActionButton action="save" label={ETVConstants.trans('reset_password')} disabled={this.state.cur_pw.trim().length===0 || this.state.new_pw1.trim().length===0 || this.state.new_pw2.trim().length===0} onClick={()=>this.resetPW()}/></>}
            >
              <Stack spacing={2.5}>
                <TextField id="username" error={!this.state.email_helper_ok} helperText={this.state.email_helper_ok?'':ETVConstants.trans('enter_valid_email_address')} label={ETVConstants.trans('username')} type="email" fullWidth autoFocus required onInput={()=>this.setState({email_helper_ok:true})} onChange={(e)=>this.setState({username:e.target.value})}/>
                <TextField id="current_pw1" error={!this.state.cur_pw_helper_ok} helperText={this.state.cur_pw_helper_ok?'':ETVConstants.trans('wrong_password')} label={ETVConstants.trans('current_password')} type="password" fullWidth required onInput={()=>this.setState({cur_pw_helper_ok:true})} onChange={(e)=>this.setState({cur_pw:e.target.value})}/>
                <TextField id="new_pw1" error={!this.state.new_pw1_helper_ok} helperText={this.state.new_pw1_helper_ok?'':ETVConstants.trans('enter_valid_password')} label={ETVConstants.trans('new_password')} type="password" fullWidth required onInput={()=>this.setState({new_pw1_helper_ok:true})} onChange={(e)=>this.setState({new_pw1:e.target.value})}/>
                <TextField id="new_pw2" error={!this.state.new_pw2_helper_ok} helperText={this.state.new_pw2_helper_ok?'':ETVConstants.trans('password_mismatch')} label={ETVConstants.trans('repeat_password')} type="password" fullWidth required onInput={()=>this.setState({new_pw2_helper_ok:true})} onChange={(e)=>this.setState({new_pw2:e.target.value})}/>
              </Stack>
            </ETVPopup>

            <ETVPopup
              open={this.state.window==='forced_pw_change_div'}
              width="small"
              title={ETVConstants.trans('please_change_password')}
              bottomActions={<ETVActionButton action="save" label={ETVConstants.trans('save')} disabled={this.state.new_pw2 !== this.state.new_pw1 || this.state.new_pw1.trim().length===0} onClick={()=>this.enforceNewPw()}/>}
            >
              <Stack spacing={1}>
                    <Typography variant='body1'>{ETVConstants.trans("secure_pw_requirements")}</Typography>
                    <Typography variant='body2'>{ETVConstants.trans("pw_at_least_1_digit")}</Typography>
                    <Typography variant='body2'>{ETVConstants.trans("pw_at_least_1_lowercase")}</Typography>
                    <Typography variant='body2'>{ETVConstants.trans("pw_at_least_1_uppercase")}</Typography>
                    <Typography variant='body2'>{ETVConstants.trans("pw_at_least_1_special_char")}</Typography>
                    <Typography variant='body2'>{ETVConstants.trans("pw_len_8_20")}</Typography>
                    <Typography variant='body2'>{ETVConstants.trans("pw_expires_183_days")}</Typography>
                    <TextField sx={{mt:2}} id="new_pw1" error={!this.state.new_pw1_helper_ok} helperText={this.state.error_reason===1?ETVConstants.trans('use_different_password'):this.state.error_reason===2?ETVConstants.trans('not_secure_password'):''} label={ETVConstants.trans('new_password')} type="password" fullWidth required onInput={()=>this.setState({new_pw1_helper_ok:true})} onChange={(e)=>this.setState({new_pw1_helper_ok:true,error_reason:0,new_pw1:e.target.value})}/>
                    <TextField sx={{mt:1}} id="new_pw2" error={!this.state.new_pw2_helper_ok} helperText={this.state.new_pw2_helper_ok?'':ETVConstants.trans('password_mismatch')} label={ETVConstants.trans('repeat_password')} type="password" fullWidth required onInput={()=>this.setState({new_pw2_helper_ok:true})} onChange={(e)=>this.setState({new_pw2_helper_ok:true,new_pw2:e.target.value})}/>
              </Stack>
            </ETVPopup>

            <ETVPopup
              open={this.state.window==='forgot_password_div'}
              onClose={()=>this.showWindow('forgot_password_div',false)}
              width="small"
              icon={<EmailIcon/>}
              title={ETVConstants.trans('send_password_reset_link')}
              bottomActions={<><ETVActionButton action="cancel" label={ETVConstants.trans('cancel')} onClick={()=>this.showWindow('forgot_password_div',false)}/><ETVActionButton action="send" label={ETVConstants.trans('send_password_reset_link')} disabled={!this.isValidEmail(this.state.send_pw_addr)} onClick={()=>this.checkResendPW()}/></>}
            >
              <TextField id="forgot_pw" error={!this.state.send_email_helper_ok} helperText={this.state.send_email_helper_ok?'':ETVConstants.trans('invalid_email')} label={ETVConstants.trans('username')} type="email" fullWidth autoFocus required onInput={()=>this.setState({send_email_helper_ok:true})} onChange={(e)=>this.setState({send_pw_addr:e.target.value})}/>
            </ETVPopup>

            <ETVPopup
                open={this.state.window==='contact_div'}
                onClose={()=>this.showWindow('contact_div',false)}
                width="small"
                title={ETVConstants.trans('contact')}
                bottomActions={<Button onClick={()=>this.showWindow('contact_div',false)}>{ETVConstants.trans('ok')}</Button>}
            >
                <Stack spacing={.5}>
                    <Typography variant='h6'>{ETVConstants.getCompany()}</Typography>
                    <Typography variant='body2'>{ETVConstants.getAddress()}</Typography>
                    <Typography variant='body2'>{ETVConstants.getCountry()}</Typography>
                    <Typography variant="body2" sx={{fontWeight:'bold',pt:2}}>{ETVConstants.getContact()}</Typography>
                </Stack>
            </ETVPopup>

            <ETVPopup
                open={this.state.window==='data_protection_div'}
                onClose={()=>this.showWindow('data_protection_div',false)}
                width="wide"
                title="Privacy Policy"
                bottomActions={<Button onClick={()=>this.showWindow('data_protection_div',false)}>{ETVConstants.trans('ok')}</Button>}
            >
                <Box sx={{maxHeight:'65vh',overflowY:'auto',pr:1}}>
                  {ETVConstants.PrivacyText()}
                </Box>
            </ETVPopup>            

            <ETVPopup
                open={this.state.window==='terms_condition_div'}
                onClose={()=>this.showWindow('terms_condition_div',false)}
                width="wide"
                title="Terms & Conditions"
                bottomActions={<Button onClick={()=>this.showWindow('terms_condition_div',false)}>{ETVConstants.trans('ok')}</Button>}
            >
                <Box sx={{maxHeight:'65vh',overflowY:'auto',pr:1}}>
                  {ETVConstants.TermsAndConditions()}
                </Box>
            </ETVPopup>              

        </div>
      );
    }
}

export default Login;
